import { computed, ref, onMounted, watch } from "vue";
import { createInjectableHook, createGlobalState } from "../components/WCurtain/index.js";
function nuxtViewportAdapter() {
  const viewportManager = useNuxtApp == null ? void 0 : useNuxtApp().$viewport;
  const isMobile = computed(
    () => (viewportManager == null ? void 0 : viewportManager.breakpoint.value) === "mobile"
  );
  const isTablet = computed(
    () => (viewportManager == null ? void 0 : viewportManager.breakpoint.value) === "tablet"
  );
  const isDesktop = computed(
    () => (viewportManager == null ? void 0 : viewportManager.breakpoint.value) === "desktop"
  );
  const breakpoint = computed(() => viewportManager == null ? void 0 : viewportManager.breakpoint.value);
  return {
    isMobile,
    isTablet,
    isDesktop,
    breakpoint
  };
}
const MOBILE_MAX = 779;
const TABLET_MAX = 1079;
function useViewportImpl() {
  if (typeof useNuxtApp === "function") {
    return nuxtViewportAdapter();
  }
  const isMobile = ref(false);
  const isTablet = ref(false);
  const isDesktop = ref(false);
  const breakpoint = computed(() => {
    return isMobile.value ? "mobile" : isTablet.value ? "tablet" : "desktop";
  });
  onMounted(() => {
    const mobileMatchMedia = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);
    const tabletMatchMedia = window.matchMedia(
      `(min-width: ${MOBILE_MAX + 1}px) and (max-width: ${TABLET_MAX}px)`
    );
    const desktopMatchMedia = window.matchMedia(
      `(min-width: ${TABLET_MAX + 1}px)`
    );
    isMobile.value = mobileMatchMedia.matches;
    isTablet.value = tabletMatchMedia.matches;
    isDesktop.value = desktopMatchMedia.matches;
    mobileMatchMedia.onchange = (e) => isMobile.value = e.matches;
    tabletMatchMedia.onchange = (e) => isTablet.value = e.matches;
    desktopMatchMedia.onchange = (e) => isDesktop.value = e.matches;
  });
  return {
    isMobile,
    isTablet,
    isDesktop,
    breakpoint
  };
}
const [useViewport, provideViewport] = createInjectableHook(useViewportImpl);
const ATTRIBUTE_NAME = "data-size";
const useBreakpointAttribute = createGlobalState(() => {
  const { breakpoint } = useViewport();
  function setBreakpointAttribute(value) {
    var _a;
    if (!document || !value) {
      return;
    }
    (_a = document.querySelector("html")) == null ? void 0 : _a.setAttribute(ATTRIBUTE_NAME, value);
  }
  watch(breakpoint, (screenType) => setBreakpointAttribute(screenType));
  onMounted(() => {
    setBreakpointAttribute(breakpoint.value);
  });
});
export {
  useBreakpointAttribute,
  useViewport
};
